var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOperationSoftFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M-1-1h582v402H-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M42.525 92.556 4.087 54.118c-3.412-3.42-3.412-8.76 0-12.17l38.438-38.44c3.42-3.42 8.76-3.42 12.17 0l38.44 38.44c3.42 3.41 3.42 8.75 0 12.17l-38.44 38.438c-3.41 3.412-8.966 3.412-12.17 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M43.385 66.714c0-.643.208-1.277.425-1.919.208-.642.642-1.068 1.068-1.493a4.484 4.484 0 0 1 1.71-1.068c.634-.217 1.276-.434 2.135-.434.851 0 1.493.217 2.136.434a4.515 4.515 0 0 1 1.701 1.068c.434.425.86.85 1.068 1.493.217.642.434 1.276.434 1.919 0 .642-.217 1.284-.434 1.927-.208.633-.634 1.067-1.068 1.493a4.73 4.73 0 0 1-1.7 1.066c-.643.209-1.285.426-2.136.426-.859 0-1.501-.217-2.135-.426-.643-.216-1.068-.642-1.71-1.067-.426-.426-.86-.86-1.068-1.493-.217-.643-.425-1.068-.425-1.927Zm8.967-9.819H44.66l-1.068-32.248h9.827z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.775 85.464 10.533 6.224a.762.762 0 0 0-1.08 0l-3.23 3.233a.762.762 0 0 0 0 1.075l79.244 79.244a.762.762 0 0 0 1.078 0l3.232-3.232a.764.764 0 0 0 0-1.078z",
    fill: "#e52030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationSoftFail);
export default __webpack_public_path__ + "static/media/operationSoftFail.d617f066a4e50c60c7ce8e939f27e2c3.svg";
export { ForwardRef as ReactComponent };